import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space4XL, space3XL } from '@xing-com/tokens';
import { Row } from '@xing-com/xing-grid';

const Container = styled.div`
  width: 99vw;
  margin-left: calc(50% - 50vw);
  margin-top: ${space4XL};
  margin-bottom: ${space3XL};

  @media ${mediaSmallOrTiny} {
    width: 100%;
    margin-left: auto;
  }
`;

const GridRow = styled(Row)`
  @media ${mediaSmallOrTiny} {
    padding: 0 !important;
  }
`;

export const Styled = {
  Container,
  GridRow,
};
